module.exports = {
  CrossStorageClient: require('./client.js'),
  CrossStorageHub:    require('./hub.js')
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/cross-storage/lib/index.js
// module id = qSlY
// module chunks = 0